module.exports = __webpack_public_path__ + "media/videoGuide.a40fd00b.mp4";